import { connect } from 'react-redux'
import { doBulkChangeMailbox } from 'actions/tickets'
import { selectPossibleMailboxesForChange } from 'selectors/mailboxes'
import ChangeInboxDropdown from './view'

const select = state => ({
  mailboxes: selectPossibleMailboxesForChange(state),
})

const perform = {
  doChangeMailbox: doBulkChangeMailbox,
}

export default connect(select, perform)(ChangeInboxDropdown)
